/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const EnableMFA_Shared_Mutation = gql`
  mutation EnableMFA_Shared_Mutation($input: AuthUserTwoFactorAuthenticationEnableInput!) {
    auth {
      userEnableTwoFactorAuthentication(input: $input) {
        clientMutationId
        twoFactorAuthentication {
          id
          isEnabled
        }
        newBackupCode
        redirectPath
        errors {
          message
        }
      }
    }
  }
`;

export { EnableMFA_Shared_Mutation };
